import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { useRef, useState } from 'react'
import { toast } from 'react-toastify'

import { postContactHidden } from '@/api/dns/postContactHidden'
import ControlNsPopup from '@/components/ui/Popups/ControlNsPopup'
import useOnClickOutside from '@/hooks/useClickOutside'
import { NAMESPACE_MANAGEMENT } from '@/res/namespaces'
import { ROUTE_DNS_MANAGEMENT } from '@/res/routes'

interface Props {
  isContactHide: boolean
  id: string
  hideRecords?: boolean
  hideControl?: boolean
}
const DropDownManagement: React.FC<Props> = ({
  isContactHide,
  id,
  hideRecords,
  hideControl,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const { t } = useTranslation(NAMESPACE_MANAGEMENT)

  const [dropDown, setDropDown] = useState(false)

  const notifySucces = () => toast.success(t('toast_succes'))

  const [isContactHidden, setIsContactHidden] = useState(isContactHide)

  const handleHideData = async (id: string) => {
    try {
      await postContactHidden(id)
      notifySucces()
    } catch (err) {
      return err
    }
    setIsContactHidden((prevState) => !prevState)
  }

  const onCloseDrop = () => {
    setDropDown(false)
  }
  const onClose = () => {
    setIsOpen(false)
  }
  const onOpen = () => {
    setIsOpen(true)
  }

  const ref = useRef()
  useOnClickOutside(ref, onCloseDrop)
  return (
    <div className="relative">
      <button
        className="inline-flex relative items-center p-1 text-sm font-medium text-center text-black bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none
            focus:ring-gray-50"
        type="button"
        onClick={() => setDropDown(!dropDown)}
      >
        <svg
          className="w-4 h-4"
          aria-hidden="true"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
        </svg>
      </button>
      <div ref={ref as any}>
        <div
          className={`absolute right-0 border z-10 bg-white rounded divide-gray-400 shadow ${
            dropDown ? 'flex' : 'hidden'
          }`}
        >
          <div className="py-1 w-[170px] text-sm text-gray-700">
            <div role="button" onClick={() => handleHideData(id)}>
              {isContactHidden ? (
                <a href="#" className="block py-2 px-4 hover:bg-gray-100">
                  {t('drop_down.show_data')}
                </a>
              ) : (
                <a href="#" className="block py-2 px-4 hover:bg-gray-100">
                  {t('drop_down.hide_data')}
                </a>
              )}
            </div>
            {hideControl ? null : (
              <div role="button" onClick={() => onOpen()}>
                {isOpen ? <ControlNsPopup id={id} onClose={onClose} /> : null}
                <a href="#" className="block py-2 px-4 hover:bg-gray-100">
                  {t('drop_down.ns_control')}
                </a>
              </div>
            )}
            {!hideRecords && (
              <Link href={`${ROUTE_DNS_MANAGEMENT}/${id}`}>
                <a className="block py-2 px-4 hover:bg-gray-100">
                  {t('drop_down.entries')}
                </a>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropDownManagement
